import React from "react"
import { connect } from "react-redux"
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom"
import AllMembers from "./members/Members"
import Member from "./members/Member"
import NewMember from "./members/New"
import SideNav from "../layout/SideNav"
import TeamsMenu from "./menu/TeamsMenu"
import DataExports from "./data-export/DataExports"
import Premium from "./"
import onMount from "../core/onMount"
import Card from "../core/Card"
import "./Enterprise.css"
import { getEnterpriseGroup } from "./members/actions"

const Enterprise = ({ match }) => (
  <div className="Enterprise">
    <div className="Main">
      <Switch>
        {/* <Route path={`${match.url}`} exact component={AllMembers}/> */}
        <Route path={`/teams/data-exports`} component={DataExports} />
        <Route path={`/teams/members/new`} exact component={NewMember} />
        <Route path={`/teams/members/:token_id`} component={Member} />
        <Route path={`/teams/members`} exact component={AllMembers} />
        <Route path={`/teams/premium`} exact component={Premium} />
      </Switch>
    </div>
  </div>
)

const MountedEnterprise = onMount(({ dispatch }) => {
  dispatch(getEnterpriseGroup())
})(Enterprise)

export default connect()(MountedEnterprise)



// WEBPACK FOOTER //
// ./src/enterprise/Enterprise.js